import {book_page} from './book/index';
import {pathIs} from "../utilities";
import {authorizations_page} from "./authorizations";
import {attorneys_page} from "./attorneys";
import {animal_catches_page} from "./animal_catches";
import {animal_deaths_page} from "./animal_deaths";
import {events_page} from "./events";
import {collective_huntings_page} from "./collective_huntings";
import {profile_page} from "./profile";
import {inventories_page} from "./inventories";
import {group_hunting_page} from "./group-hunting";
import {dashboard_page} from "./dashboard";
import {reckonings_page} from "./reckonings";
import {reports_page} from "./reports";
import {messages_page} from "./messages";
import {logs_page} from "./logs";
import {sms_page} from "./sms";
import {contracts_page} from "./contracts";
import {zipod_page} from "./zipod";
import {EpBdlLayer} from "../map/layers/bdl";
import {resolutions_page} from "./resolutions";

try {
    if (pathIs(['/app', '/app/'])) {
        dashboard_page();
    }

    if (pathIs(['/app/book', '/app/book/*', '/app/map'])) {
        book_page();
    }

    if (pathIs(['/app/authorizations', '/app/authorizations/*', '/app/profile/authorizations', '/app/profile/authorizations/*'])) {
        authorizations_page();
    }

    if (pathIs(['/app/profile/attorneys', '/app/profile/attorneys/*'])) {
        attorneys_page();
    }

    if (pathIs(['/app/plan/catches', '/app/plan/catches/*'])) {
        animal_catches_page();
    }

    if (pathIs(['/app/plan/deaths', '/app/plan/deaths/*'])) {
        animal_deaths_page();
    }

    if (pathIs(['/app/events', '/app/events/*'])) {
        events_page();
    }

    if (pathIs(['/app/plan/huntings', '/app/plan/huntings/*', '/app/plan/hunting', '/app/plan/hunting/*' ])) {
        collective_huntings_page();
    }

    if (pathIs(['/app/profile', '/app/profile/*', '/app/profile*'])) {
        profile_page();
    }

    if (pathIs(['/app/inventories', '/app/inventories/*', '/app/inventories*'])) {
        inventories_page();
    }

    if (pathIs(['/app/group-hunting', '/app/group-hunting/*', '/app/group-hunting*'])) {
        group_hunting_page();
    }

    if (pathIs(['/app/reckonings', '/app/reckonings/*', '/app/reckonings*'])) {
        reckonings_page();
    }

    if(pathIs(['/app/reports', '/app/reports/*', '/app/reports*'])) {
        reports_page();
    }

    if(pathIs(['/app/messages', '/app/messages/*', '/app/messages*'])) {
        messages_page();
    }
    if(pathIs(['/app/logs'])) {
        logs_page();
    }
    if(pathIs(['/app/sms', 'app/sms/*', 'app/sms*', '/app/sms/history', '/app/sms/order'])) {
        sms_page();
    }
    if(pathIs(['/app/plan/contracts', '/app/plan/contracts*'])) {
        contracts_page();
    }
    if(pathIs(['/app/zipod/*', '/app/zipod*'])) {
        zipod_page();
    }
    if (pathIs(['/app/resolutions', '/app/resolutions/*'])) {
        resolutions_page();
    }

    // load data
    (() => {
        if(typeof window != 'undefined' && typeof localStorage != 'undefined' && pathIs('/*')) {
            const previousVersion = localStorage.getItem('version') ?? null;
            const versionDiffers = previousVersion === null || previousVersion !== window.App.version;

            localStorage.setItem('version', window.App.version);

            if(versionDiffers || !EpBdlLayer.hasAnyLayersInLocalStorage()) {
                EpBdlLayer.saveAvailableLayersToLocalStorage();
            }
        }
    })()
} catch(err) {
    console.error(err);
}
